/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lg_Focus_ActionInputs */

const en_lg_focus_action = /** @type {(inputs: Lg_Focus_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set up focus and audio`)
};

const id_lg_focus_action = /** @type {(inputs: Lg_Focus_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atur fokus dan audio`)
};

/**
* | output |
* | --- |
* | "Set up focus and audio" |
*
* @param {Lg_Focus_ActionInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const lg_focus_action = /** @type {((inputs?: Lg_Focus_ActionInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lg_Focus_ActionInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lg_focus_action(inputs)
	return en_lg_focus_action(inputs)
});